var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchMagGlassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.222 0a6.222 6.222 0 014.916 10.038l2.94 2.94-1.1 1.1-2.94-2.94A6.222 6.222 0 116.222 0zm0 1.556a4.667 4.667 0 100 9.333 4.667 4.667 0 000-9.333z",
    opacity: 0.832
  })));
}

export default __webpack_public_path__ + "2751c8c9d11b564ecd84e2a8642b8a50.svg";
export { SvgSearchMagGlassIcon as ReactComponent };